import React from "react";
import { useSpring } from "@react-spring/core";
import { animated } from "@react-spring/web";

const maxWidth = `16px`;

export const ProgressBar = ({
  className = ``,
  current = 0,
  total = 5,
  show = true,
}) => {
  const { height, width, opacity } = useSpring({
    width: maxWidth,
    height: `50vh`,
    opacity: Number(show),
    // reset: true
  });

  return (
    <animated.div className={`${className}`} style={{ height, width, opacity }}>
      {Array(total)
        .fill(0)
        .map((d, i) => (
          <div
            key={`progress-indicator-${i}`}
            className="flex flex-column items-center z3"
          >
            <Marker active={current === i} />
          </div>
        ))}
    </animated.div>
  );
};

const Marker = ({ active = false }) => {
  const inactiveWidth = `8px`;
  const activeWidth = `16px`;

  const { width, height, backgroundColor } = useSpring({
    width: active ? activeWidth : inactiveWidth,
    height: active ? activeWidth : inactiveWidth,
    backgroundColor: active ? `var(--white)` : `var(--gray)`,
  });

  return (
    <animated.div
      className="my1 pointer"
      style={{
        width,
        height,
        backgroundColor,
        borderRadius: `50%`,
      }}
    />
  );
};
